import { render, staticRenderFns } from "./setOrderinfor.vue?vue&type=template&id=5e88b453&scoped=true"
import script from "./setOrderinfor.vue?vue&type=script&lang=js"
export * from "./setOrderinfor.vue?vue&type=script&lang=js"
import style0 from "./setOrderinfor.vue?vue&type=style&index=0&id=5e88b453&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e88b453",
  null
  
)

export default component.exports